export default __webpack_public_path__ + "static/media/Astro_Taurus_White.57004af0.png";